export default __webpack_public_path__ + "static/media/007-Panama Hat.074a32f2.svg";